// Handles are stored bare across platforms; show a leading @ to users. A pasted URL /
// unresolved short link (or a name/list fallback, which carries a space) is left untouched
// so an @ never mangles it.
export const formatHandle = (platform: string, handle: string | null): string => {
    if (!handle) return '';
    const bare = handle.replace(/^@+/, '');
    if (/[/\s]/.test(bare)) return handle;
    return `@${bare}`;
};
